//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import styles from './style.module.scss';
import { ReactComponent as BackIcon } from '../../../assets/images/arrowLeft.svg';
import { ReactComponent as CornerIcon } from '../../../assets/images/corner.svg';
import { t } from '@web-solutions/module-localization';
import { useNav } from 'src/onboarding/hooks/nav';
import Button from 'src/onboarding/components/ui/button/Button';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import { useEffect } from 'react';
import { useRemoteConfig } from '@web-solutions/base-app/hooks/use-remote-config';

const NUTRIENTS = [
  { value: '480', label: 'kcal' },
  { value: '26g', label: 'protein' },
  { value: '22g', label: 'carbs' },
  { value: '22g', label: 'fat' },
];

function TransitionEighth() {
  const { onNext, onPrev, currentIndex } = useNav();

  useEffect(() => {
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  return (
    <div className={styles.page}>
      {currentIndex !== 0 && (
        <div className={styles.back} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={styles.wrapperInfo}>
        <Title className={styles.title}>{t('onboarding.logMeals.title')}</Title>
      </div>
      <div className={styles.wrapper}>
        <div className={styles.phone}></div>
        <div className={styles.meal}>
          <CornerIcon className={styles.cornerBottomLeft} />
          <CornerIcon className={styles.cornerBottomRight} />
          <CornerIcon className={styles.cornerTopLeft} />
          <CornerIcon className={styles.cornerTopRight} />
        </div>
      </div>
      <div className={styles.overlayHighlight}></div>
      <div className={styles.nutrientsCard}>
        {NUTRIENTS.map((item, index) => (
          <div className={styles.nutrientItem} key={index}>
            <div className={styles.nutrientValue}>{item.value}</div>
            <div className={styles.nutrientLabel}>{item.label}</div>
          </div>
        ))}
      </div>
      <div className={styles.message}>
        {t('onboarding.logMeals.good')} <span></span>
      </div>
      <div className={styles.continue}>
        <div className={styles.blur}></div>

        <Button onClick={onNext} title={t('onboarding.logMeals.continue')} />
      </div>
    </div>
  );
}

export default TransitionEighth;
